import { createFileRoute } from '@tanstack/react-router'
import node, {
  type accountLayoutQuery,
} from '#gen/relay/accountLayoutQuery.graphql'
import { lazyLoadedComponent } from '#lib/routing/lazy-loaded-component'
import { SidenavPageLayoutSkeleton } from '#lib/skeletons/sidenav-page-layout-skeleton'

export const Route = createFileRoute('/_dashboard/$account')({
  staticData: { title: '' },
  staleTime: 30_000,
  async loader({ context }) {
    return context.preload<accountLayoutQuery>(node)
  },
  pendingComponent: SidenavPageLayoutSkeleton,
  component: lazyLoadedComponent(
    () => import('#app/pages/account/account-layout'),
    'AccountLayout',
  ),
})
